var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F4F4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3930_8208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7801 3.21959C20.6394 3.07899 20.4487 3 20.2498 3C20.051 3 19.8602 3.07899 19.7196 3.21959L11.9998 10.9393L4.28009 3.21959C4.13944 3.07899 3.94871 3 3.74984 3C3.55097 3 3.36024 3.07899 3.21959 3.21959C3.07899 3.36024 3 3.55097 3 3.74984C3 3.94871 3.07899 4.13944 3.21959 4.28009L10.9393 11.9998L3.21959 19.7196C3.07899 19.8602 3 20.051 3 20.2498C3 20.4487 3.07899 20.6394 3.21959 20.7801C3.36024 20.9207 3.55097 20.9997 3.74984 20.9997C3.94871 20.9997 4.13944 20.9207 4.28009 20.7801L11.9998 13.0603L19.7196 20.7801C19.8602 20.9207 20.051 20.9997 20.2498 20.9997C20.4487 20.9997 20.6394 20.9207 20.7801 20.7801C20.9207 20.6394 20.9997 20.4487 20.9997 20.2498C20.9997 20.051 20.9207 19.8602 20.7801 19.7196L13.0603 11.9998L20.7801 4.28009C20.9207 4.13944 20.9997 3.94871 20.9997 3.74984C20.9997 3.55097 20.9207 3.36024 20.7801 3.21959Z",
    fill: "#314155"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3930_8208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.afd042aa.svg";
export { ForwardRef as ReactComponent };